import React from "react";

import { appDate } from "@/utils/date"

import AppIcon from "@/components/AppIcon";
import AppBox from "@/components/AppBox";
import AppTooltip from "@/components/AppTooltip";

interface MessageProps {
  text: string;
  created_at: string;
  outcoming: boolean;
  sent?: boolean;
  delivered?: boolean;
  id: string;
}

interface AppDialogMessageProps {
  message: MessageProps;
}

const Message: React.FC<AppDialogMessageProps> = ({ message }) => {
  return (
    <AppBox fullWidth justify={message.outcoming ? "end" : "start"}>
      <AppBox
        column
        gap={2}
        className={`w-10/12 lg:w-1/2 p-4 rounded-md ${
          message.outcoming
            ? "bg-green-100 text-gray-800"
            : "bg-gray-100 text-gray-800"
        }`}
      >
        {/* Message Text */}
        <AppBox>{message.text}</AppBox>

        {/* Footer */}
        <AppBox justify="start" gap={2} align="center" className="text-sm text-gray-500">
          { appDate(message.created_at) }
          {message.outcoming &&
            (message.sent || message.delivered) && (
              <AppTooltip title={message.sent && ! message.delivered ? 'Message sent' : (message.delivered ? 'Message delivered' : 'Message not sent')}>
                <AppBox>
                  {message.sent && !message.delivered ? (
                    <AppIcon name="check" size="sm" className="text-primary" />
                  ) : message.delivered ? (
                    <AppIcon name="checkCheck" size="sm" className="text-primary" />
                  ) : null}
                </AppBox>
              </AppTooltip>
            )}
        </AppBox>
      </AppBox>
    </AppBox>
  );
};

export default Message;